import { atom } from 'jotai'

/**
 * 配送依頼Drawerで使用する前回の拠点ID
 * Drawerが閉じている間も保持するため、Atomで管理する
 */
export const prevSelectedDcIdForShipmentOrderDrawerAtom = atom<number | null>(
  null
)

prevSelectedDcIdForShipmentOrderDrawerAtom.debugLabel =
  'prevSelectedDcIdForShipmentOrderDrawerAtom'
